module.exports = __webpack_public_path__ + "img/icon_green_medal.f49e11a1.png";